import type { Locale } from "../types/app";

export const messages = {
  ar: {
    appName: "أذكاري",
    appTagline: "أذكار وقرآن وصدقة في تجربة هادئة",
    startAthkar: "ابدأ أذكارك اليوم",
    readQuran: "اقرأ القرآن الكريم",
    donate: "ساهم في الصدقة والزكاة",
    home: "الرئيسية",
    athkar: "الأذكار",
    quran: "القرآن",
    donateNav: "التبرع",
    qibla: "القبلة",
    moon: "القمر",
    favorites: "المفضلة",
    about: "عن التطبيق",
    contact: "تواصل",
    settings: "الإعدادات",
    search: "بحث",
    loading: "جاري التحميل",
    retry: "إعادة المحاولة",
    empty: "لا توجد نتائج مطابقة.",
    error: "حدث خطأ غير متوقع.",
    offline: "يبدو أنك دون اتصال. سنعرض ما تم حفظه عند توفره.",
    copied: "تم النسخ",
    share: "مشاركة",
    copy: "نسخ",
    completed: "مكتمل",
    reset: "تصفير",
    progress: "التقدم",
    repeat: "التكرار",
    source: "المصدر",
    listen: "استماع",
    continueReading: "متابعة القراءة",
    partOfPlatform: "تطبيق أذكاري من Issa Al-Mawali | عيسى المعولي",
    externalNotice: "سيتم فتح بوابة رسمية خارج التطبيق. تحقق من الرابط قبل الدفع.",
    officialLinksOnly: "روابط رسمية للتبرع بالزكاة والصدقة.",
    footerLine: "Athkari App by Issa Al-Mawali | عيسى المعولي",
    lightweight: "النمط الخفيف",
    language: "اللغة",
    theme: "السمة",
    accent: "اللون",
    visualStyle: "النمط",
    textSize: "حجم النص",
    motion: "الحركة",
    sounds: "الأصوات",
    notifications: "الإشعارات",
    hijriOffset: "تصحيح التاريخ الهجري",
    hijriOffsetDesc: "اضبط بمقدار يوم إذا كان بلدك يرى الهلال مبكراً أو متأخراً عن عُمان."
  },
  en: {
    appName: "Athkari",
    appTagline: "Athkar, Quran, and giving in a calm daily app",
    startAthkar: "Start today's Athkar",
    readQuran: "Read the Holy Quran",
    donate: "Give Sadaqah or Zakah",
    home: "Home",
    athkar: "Athkar",
    quran: "Quran",
    donateNav: "Donate",
    qibla: "Qibla",
    moon: "Moon",
    favorites: "Favorites",
    about: "About",
    contact: "Contact",
    settings: "Settings",
    search: "Search",
    loading: "Loading",
    retry: "Retry",
    empty: "No matching results.",
    error: "Something went wrong.",
    offline: "You appear offline. Cached content will be shown when available.",
    copied: "Copied",
    share: "Share",
    copy: "Copy",
    completed: "Completed",
    reset: "Reset",
    progress: "Progress",
    repeat: "Repeat",
    source: "Source",
    listen: "Listen",
    continueReading: "Continue reading",
    partOfPlatform: "Athkari App by Issa Al-Mawali | عيسى المعولي",
    externalNotice: "An official external portal will open. Please verify the link before paying.",
    officialLinksOnly: "Official links for Zakah and Sadaqah giving.",
    footerLine: "Athkari App by Issa Al-Mawali | عيسى المعولي",
    lightweight: "Lightweight mode",
    language: "Language",
    theme: "Theme",
    accent: "Accent",
    visualStyle: "Style",
    textSize: "Text size",
    motion: "Motion",
    sounds: "Sounds",
    notifications: "Notifications",
    hijriOffset: "Hijri date correction",
    hijriOffsetDesc: "Adjust by a day if your country sights the moon earlier or later than Oman."
  }
} as const;

export type MessageKey = keyof typeof messages.ar;

export function t(locale: Locale, key: MessageKey): string {
  return messages[locale][key] ?? messages.ar[key];
}
